import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhitePaper from "../assets/friggawhitepapers/FinancialDiplomacyVsBusinessNotWar.pdf";
import "./FinancialDiplomacyStyles.css";

function PublicationsAndInsightsPage() {
  const [email, setEmail] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("findipWhitepaperUnlocked") === "true") {
      setIsUnlocked(true);
    }
  }, []);

  const handleWhitepaperAccess = (event) => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      event.preventDefault();
      setError("Please enter your email address.");
      return;
    }

    setError("");
    setHasSubmitted(true);
  };

  const handleFormSubmitLoaded = () => {
    if (!hasSubmitted) {
      return;
    }
    localStorage.setItem("findipWhitepaperUnlocked", "true");
    setIsUnlocked(true);
  };

  return (
    <>
      <Navbar />
      <div className="findip-container">
        <h1>Publications & Insights</h1>
        <details className="findip-item" open>
          <summary>White Paper: Financial Diplomacy vs. "Business Not War"</summary>
          <p className="findip-subtitle">
          </p>
          <p>
            Our most recent white paper introduces the core concepts and frameworks of
            Financial Diplomacy, the strategic use of economic tools,
            institutional development, and international cooperation to achieve
            security and stability objectives that military force alone cannot
            accomplish.
          </p>

          {!isUnlocked ? (
            <form
              className="findip-gate"
              action="https://formsubmit.co/contact@friggacg.com"
              method="POST"
              target="formsubmit-hidden-frame"
              onSubmit={handleWhitepaperAccess}
            >
              <iframe
                title="FormSubmit Hidden Frame"
                name="formsubmit-hidden-frame"
                className="findip-hidden-frame"
                onLoad={handleFormSubmitLoaded}
              ></iframe>
              <input type="hidden" name="name" value="FinDIP Whitepaper Request" />
              <input type="hidden" name="_subject" value="New Whitepaper Download Request" />
              <input type="hidden" name="subject" value="FinDIP Whitepaper Request" />
              <input
                type="hidden"
                name="message"
                value="A visitor requested access to the Financial Diplomacy whitepaper."
              />
              <input type="hidden" name="source" value="Frigga FinDIP whitepaper gate" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <label htmlFor="whitepaper-email">
                Enter your email to access the white paper:
              </label>
              <input
                id="whitepaper-email"
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
                required
              />
              <button className="findip-button" type="submit">Get Access</button>
              <p className="findip-gate-note">
                By submitting your email, you agree to receive the requested
                white paper and related communications from Frigga. See our{" "}
                <Link to="/privacy">Privacy Policy</Link>.
              </p>
              {error ? <p className="findip-gate-error">{error}</p> : null}
            </form>
          ) : (
            <a
              className="findip-button"
              href={WhitePaper}
              download="Financial-Diplomacy-White-Paper.pdf"
            >
              Download White Paper
            </a>
          )}
        </details>
      </div>
      <Footer />
    </>
  );
}

export default PublicationsAndInsightsPage;
